/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/order';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveOrderRequest": {
                    "fields": {
                      "orderNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveOrderResponse": {
                    "fields": {
                      "order": {
                        "type": "squareup.solidshop.v2.resources.Order",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE RetrieveOrderRequest @ squareup/solidshop/v2/service/orders/retrieve_order.proto at 11:1
 */
export const RetrieveOrderRequest = $root.lookupType('squareup.solidshop.v2.service.RetrieveOrderRequest');
fixType(RetrieveOrderRequest);
Builder.createAndAttachToType(RetrieveOrderRequest);
/**
 * SOURCE RetrieveOrderResponse @ squareup/solidshop/v2/service/orders/retrieve_order.proto at 16:1
 */
export const RetrieveOrderResponse = $root.lookupType('squareup.solidshop.v2.service.RetrieveOrderResponse');
fixType(RetrieveOrderResponse);
Builder.createAndAttachToType(RetrieveOrderResponse);
